import { IonGrid, IonInfiniteScroll, IonInfiniteScrollContent, IonList, IonRefresherContent, IonRefresher, useIonViewWillEnter, useIonRouter, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useRef, useState,useEffect } from "react";
import adapter from 'webrtc-adapter';

import { showTab, updateTab } from "../components/Tabs";
import { showAlert, showConfirm } from '../components/Alert';
import NServer, { UIElement } from "../components/NServer";
import Vault from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";
import ContentView from "../components/ContentView";
import { ContentInfo } from "../data/item";

import './Main.css'; 

var index = 0;
const total = 5;

const CAPTURE_OPTIONS = {
    audio: true,
    video: { facingMode: "user" }
};

const Vote : React.FC = () => {

    const videoRef = useRef<any>(null);
    const [mediaStream, setMediaStream] = useState<any>(null);

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        
        openMediaStream();

        showTab();
    });

    // retrieve the media stream
    const openMediaStream = async () => {
        try {
            let stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
            alert("Success!");

            setMediaStream(stream);
        } 
        catch (error) {
            alert("media error: " + error);
        }
    }
    
    // refresh event
    const doRefresh = async (ev : any) => {
        ev.detail.complete();
    };

    useEffect(() => {
        if (mediaStream && videoRef.current) {
            videoRef.current.srcObject = mediaStream;
        }
    }, [mediaStream]);

    const handleCanPlay = () => {
        videoRef.current.play();
    }

    return (
        <IonPage>
            <IonHeader>
                <IonItem lines="none"></IonItem>
            </IonHeader>
            <IonContent>
                <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                
                <video ref={videoRef} onCanPlay={handleCanPlay} autoPlay playsInline loop className={"full-camera"} />
            </IonContent>
        </IonPage>
    );
};

export default Vote;